import React from 'react';

export default (props) => (
  <svg
    height={props.height}
    width={props.width}
    style={{ position: props.position }}
    id="exclamation-mark"
    fill="#C15D26"
    fillRule="nonzero"
    // viewBox="-550 -50 700 700"
    viewBox={props.viewBox ? props.viewBox : '0 0 700 700'}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="50px"
    y="5px"
  >
    <path
      d="M117.027,233.236 C52.844,233.236 0.818,181.21 0.818,117.027 C0.818,52.844 52.844,0.818 117.027,0.818 C181.21,0.818 233.236,52.844 233.236,117.027 C233.236,181.21 181.21,233.236 117.027,233.236 Z M117.036,36.726 C106.792,36.726 99.041,42.072 99.041,50.707 L99.041,129.908 C99.041,138.552 106.791,143.88 117.036,143.88 C127.03,143.88 135.031,138.329 135.031,129.908 L135.031,50.707 C135.03,42.277 127.03,36.726 117.036,36.726 Z M117.036,161.723 C107.194,161.723 99.184,169.733 99.184,179.583 C99.184,189.416 107.194,197.426 117.036,197.426 C126.878,197.426 134.879,189.416 134.879,179.583 C134.878,169.732 126.878,161.723 117.036,161.723 Z"
      id="Shape"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/common/icons/IconExclamationPoint.js